import { asyncOpenModal } from '@helpers/ModalHelper'

// Public: Helper for the user profile survey modal.
export function showUserProfileSurveyIfApplies ({ currentUser, careProvider }) {
  if (!currentUser.displayPostLoginUserProfileModal) { return }

  asyncOpenModal('Users/UserProfileSurveyModal', { props: { userId: currentUser.id } })
}
